
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/genel-kariyer-basvuru",
      function () {
        return require("private-next-pages/genel-kariyer-basvuru.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/genel-kariyer-basvuru"])
      });
    }
  